// Inter variable font with the optical-size axis (the genuine "Inter Display" cut at large sizes).
import "@fontsource-variable/inter/opsz.css";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { config } from "./config";
import "./styles.css";

const posthogOptions = {
  api_host: config.posthogHost,
  capture_pageview: false,
  person_profiles: "identified_only" as const,
};

if (config.posthogKey) {
  if (!(posthog as { __loaded?: boolean }).__loaded) {
    posthog.init(config.posthogKey, posthogOptions);
  } else {
    posthog.set_config(posthogOptions);
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {config.posthogKey ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>,
);
